export default __webpack_public_path__ + "assets/d4d7c0a7dbe4c79217723be29b2b9896.woff2";